export class rodeoExpenseItems{
    id:number;
    rodeoId:number;
    description:string;
    expenseCategory:ExpenseCategory;
    amount:string;
}

export enum ExpenseCategory {
    Labor = 'Labor',
    Cattle = 'Cattle',
    Equipment = 'Equipment',
    Materials = 'Materials',
    Misc = 'Misc',
  }


// WEBPACK FOOTER //
// ./src/model/rodeoExpenseItems.ts